import { HttpClient } from '@core/httpClient';
import { END_POINTS } from '@services/urls';

import { buildPathWithParams } from '@utils/urls';

import {
  TPaymentDetails,
  TPaymentLinkDetails,
  TPaymentRequestData,
  TPaymentResponseData,
} from './types';

export class PaymentService {
  public static getPaymentDetails = async (paymentExternalId: string): Promise<TPaymentDetails> => {
    try {
      const response = await HttpClient.GET<TPaymentDetails>({
        url: buildPathWithParams(END_POINTS.paymentDetails, { paymentExternalId }),
      });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  public static getPaymentLinkDetails = async (
    paymentLinkId: string,
  ): Promise<TPaymentLinkDetails> => {
    try {
      const response = await HttpClient.GET<TPaymentLinkDetails>({
        url: buildPathWithParams(END_POINTS.paymentLinkDetails, { paymentLinkId }),
        useQueryParams: false,
      });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  /**
   * @deprecated - Manual payment creation is no longer required.
   * Use the description and payment-link parameters directly in the library instead.
   */
  public static createCheckoutPayment = async (
    paymentRequestData: TPaymentRequestData,
  ): Promise<TPaymentResponseData> => {
    try {
      const dataPayload = {
        app_id: paymentRequestData.appId,
        environment: import.meta.env.VITE_ENV,
      };

      const encoded = btoa(unescape(JSON.stringify(dataPayload)));
      HttpClient.setAppDataRequest(encoded);

      const response = await HttpClient.POST<TPaymentResponseData>({
        url: END_POINTS.createPayment,
        data: paymentRequestData,
        useQueryParams: true,
      });

      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  };
}
